import "./Footer.css";
import Logo from "./Logo.jsx";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__content">
        <div>
          <div className="footer__brand">
            <Logo size={36} theme="light" />
          </div>
          <p className="footer__tagline">
            Technology consulting for leaders who need to move fast and confidently.
          </p>
        </div>
        <div className="footer__nav">
          <a href="#services">Services</a>
          <a href="#experience">Experience</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </div>
      </div>
      <div className="footer__meta">
        <span>© {new Date().getFullYear()} XcelerateIT. All rights reserved.</span>
        <a href="mailto:xcelerateit@outlook.com">xcelerateit@outlook.com</a>
      </div>
    </footer>
  );
}

export default Footer;
